import { MicrobitScreen } from "../../features/microbit";

/** FS-MB 마이크로비트 놀이터 — 페이지는 조립만 한다(CSG 4.2). 화면 본체는 features/microbit */
export default function MicrobitPage() {
  return <MicrobitScreen />;
}
